'use es6';

export var DIRECTORY_PAGE_PATH = 'products';
export var GOOD_DETAILS_PATH = DIRECTORY_PAGE_PATH + "/:providerUrlToken/:goodNameUrlToken";
export var GOOD_DETAILS_DEMO_PATH = GOOD_DETAILS_PATH + "/demo";
export var GOOD_DETAILS_PREVIEW_PATH = GOOD_DETAILS_PATH + "/preview";
export var GOOD_DETAILS_REVIEW_PATH = GOOD_DETAILS_PATH + "/review";
export var MANAGE_PURCHASES_PATH = 'manage-purchases';